// implementation of a checkbox filter

import {Filter, FilterProps} from "../Filter";
import {html} from "htm/preact";

interface CheckboxProps extends FilterProps {
    options: { name: string; value: string }[];
    selected: Option[];
    onChange?: (filter: Filter) => void;
}

interface Option{
    name: string;
    value: string;
}

export class Checkbox extends Filter<CheckboxProps> {
    buildOptions: any[] = [];

    cleared: any = { selected: []};

    constructor(props: any) {
        super(props);

        this.clear = this.clear.bind(this);

        //add options
        if(props.options){
            props.options.forEach((option: any) => {
                if(this.state.value.selected)
                {
                    if(this.state.value.selected.includes(option.value)){
                        this.buildOptions.push({ name: option.name, value: option.value, checked: true });
                    }
                    else{
                        this.buildOptions.push({ name: option.name, value: option.value, checked: false });
                    }
                }

            });
        }

    }

    render() {
        return html `
            <div class="content">
                <div class="form-group">
                    <div class="govuk-checkboxes">
                        ${this.buildOptions.map(option => html `
                            <div class="govuk-checkboxes__item">
                                <input class="govuk-checkboxes__input" id="${option.value}" name="${option.value}" type="checkbox" value="${option.value}" checked="${ this.state.value.selected?.includes(option.value) }"  onChange=${this.handleToggle.bind(this)}/>
                                <label class="govuk-label govuk-checkboxes__label" for="${option.value}">
                                    ${option.name}
                                </label>
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        `
    }

    private handleToggle = (e: Event) => {
        const input   = e.target as HTMLInputElement;
        const { value, checked } = input;

        if(checked){
            this.addOptionToState(value);
        }
        else{
            this.removeOptionFromState(value);
        }

    }

    getQueryParam(): Record<string, string> {
        let selectedValues = this.state.value.selected;
        let params: { [key: string]: string } = {};

        for(let i = 0; i < selectedValues.length; i++){
            params[selectedValues[i]] = "true";
        }

        return params;
    }
}